import { SiteLayout } from "./SiteLayout";
import { useSiteTranslation } from "./i18n";
import { HeroSection } from "./sections/HeroSection";
import { PrinciplesSection } from "./sections/PrinciplesSection";
import { WhySection } from "./sections/WhySection";
import { JourneySection } from "./sections/JourneySection";
import { ScreensGallery } from "./sections/ScreensGallery";
import { FeaturesSection } from "./sections/FeaturesSection";
import { IslamicCornerSection } from "./sections/IslamicCornerSection";
import { DarkModeSection } from "./sections/DarkModeSection";
import { FreePromiseSection } from "./sections/FreePromiseSection";
import { MarriageRewardSection } from "./sections/MarriageRewardSection";
import { MARRIAGE_REWARD_ENABLED } from "./data/reward";
import { FaqSection } from "./sections/FaqSection";
import { DownloadSection } from "./sections/DownloadSection";

export default function HomePage() {
  const { t } = useSiteTranslation();
  return (
    <SiteLayout title={t("home.title")}>
      <HeroSection />
      <PrinciplesSection />
      <WhySection />
      <JourneySection />
      <ScreensGallery />
      <FeaturesSection />
      <IslamicCornerSection />
      <DarkModeSection />
      <FreePromiseSection />
      {MARRIAGE_REWARD_ENABLED && <MarriageRewardSection />}
      <FaqSection />
      <DownloadSection />
    </SiteLayout>
  );
}
